export default {
    origin: "Origen",
    destination: "Destinación",
    date: "Fecha",
    dates: "Fechas",
    microtrips: "Microtrips",
    "Select a origin": "Seleccione un origen",
    "Select a destination": "Seleccione una destinación",
    "Select a province": "Seleccione una provincia",
    orDestination: "o una destinación",
    "Total trips": "Desplazamientos totales",
    "In/Out trips": "Desplazamientos In/Out",
    "In/In trips": "Desplazamientos In/In",
    moreStats: "Para más estadísticas visite",
    spain: "España",
    username: "Usuario",
    password: "Contraseña",
    login: "Acceso",
    cancel: "Cancelar",
    ok: "Acceder",
    help: "Click izquierdo para seleccionar origen, click derecho para seleccionar destinación",
    "reset origin": "Borrar origen",
    "reset destination": "Borrar destinación",
    flip: "Intercambiar origen-destinación",
    accept: "Aceptar",
    "info btn": "Notas técnicas y metodología",
    "<1h": "Menos de 1 h.",
    "1h<6h": "Entre 1h. y 6h.",
    "6h<12h": "Entre 7h. y 12 h.",
    ">12h": "Más de 2 h.",
    week: "Semana",
    month: "Mes",
    selectAverage: "Seleccione una media",
    languages: "Idioma",
    country: "País",
    "Select an average": "Seleccione una media",
    daily: "Diaria",
    weekly: "Semanal",
    monthly: "Mensual",
    average: "Media",
    nationalities: "País",
    census: "Census defined",
    "Select a nationality": "Seleccione un país",
    ca: "Seleccione una C.A.",
    "Roamers per day": "Roamers por día",
    from: "de",
    "Roamers per nationality": "Roamers por país",
    light: "Modo claro",
    night: "Modo oscuro",
    layout: "Layout",
    "Total trips per day": "Desplazamientos por día",
    "Select an origin": "Seleccione un origen",
    "Total trips per origin": "Desplazamientos por origen",
    "Visits per origin": "Visitas por origen",
    trips: "desp.",
    national: "Nacional",
    international: "Internacional",
    nationals: "Nacionales",
    internationals: "Internacionales",
    "Roamers per province": "Visitas por provincia",
    //PDF - LOL
    period: "Periodo",
    report: "Nombre del reporte",
    requested: "Solicitado por",
    hosting: "<span>Host / Hosting Area</span>",
    geo_selection: "Selección Geográfica",
    vis_reference: "Referencia Visual",
    location_type: "Tipo de ubicación",
    province: "Provincia",
    provinces: "provincias",
    region: "Comarca",
    municipality: "Municipio",
    distric: "Distrito",
    dataset_parameters: "Parámetros de análisis",
    main_metrics: "Indicadores principales",
    pop_res: "Población observada",
    total_uniques: "Visitantes únicos",
    regulars: "Regulares",
    national_visitors: "Visitantes Nacionales",
    international_visitors: "Visitantes Internacionales",
    ranking_vs: "Ranking Vs otras municipalidades",
    same_period: "Mismo período ",
    all: "Todos",
    pobl: "Población",
    all_metrics: "Todas las métricas corresponden al período de análisis de lo contrario especificado",
    selected_period: "Período seleccionado",
    busiest_day: "Día de mayor afluencia",
    busiest_time: "Horario de mayor afluencia",
    unique_visitors_act: "Actividad de Visitantes únicos",
    visitors_day: "Visitantes por el día",
    overnight_visitors: "Visitantes pernoctando",
    by_length: "Por tiempo de permanencia",
    daytime_visitors: "Visitantes diurnos",
    uniques_hour: "Visitantes únicos por hora",
    by_province: "Provincia de origen",
    by_country: "Pais de origen",
    glossary: "Glosario",
    "1 Night": "1 Noche",
    "2 Nights": "2 Noches",
    "3 Nights": "3 Noches",
    "More than 3 nights": "Más de 3 noches",
    COM: "Comarca",
    PRO: "Provincia",
    MUN: "Municipio",
    DISC: "Distrito",
    SEC: "Sección",
    county: "Comunidad",
    counties: "comarcas",
    avgStayN: "Estancia media en NOCHES",
    municipalities: "municipios",
    districts: "distritos",
    glos1: "Es el área geográfica en la que se ofrecen los datos, tanto a nivel de reporte como también en cuanto a nuestros otros servicios. Esta área puede ser (en el caso del turismo):",
    glos2: "<span>Residente (también entendido como población)</span>: Usuarios cuyo hogar coincide con el alojamiento o el área de hospedaje. Para que un usuario sea considerado residente, deben haber pasado al menos 14 noches consecutivas (pernoctaciones) o 16 noches no consecutivas durante los últimos 30 días dentro del área de hospedaje. Se entiende como una estancia de una noche, cuando el último evento de un día y el primero del siguiente ocurren en el mismo área de hospedaje.",
    glos3: "<span>Regulares</span>: usuarios cuyo trabajo coincide con el área de hospedaje. Para que un usuario sea considerado regular, tienen que haber sido vistos durante al menos 5 días hábiles no consecutivos durante los últimos 30 días en el área de hospedaje  y durante  al menos 30 minutos cada día, entre las 06:00 y las 22:00 también dentro del área mencionada.",
    glos4: "<span>Visitantes únicos</span>:cualquier usuario que, sin ser un residente habitual o residente, haya tenido estancias por un total de al menos 30 minutos en el área de hospedaje  (agregando todas las estancias para un día determinado dentro del área mencionada). Se cuentan diariamente para cada área de hospedaje. Un usuario que desayuna en el área de hospedaje, como en la siguiente ciudad, y cena en el área de hospedaje, es contabilizado como visitante.",
    glos5: "<i>Categoría 1</i>:<ul><li><span>Nacional</span>: cuyo hogar se encuentra dentro de España (provincia) </li><li><span>Internacional</span>: cuyo hogar no se encuentra dentro de España (país)</li></ul>",
    glos6: "<i>Categoría 2</i>:<ul><li><span>Hiker</span>: visitante único cuyas estancias suman un total de al menos 30 minutos en el anfitrión pero no ha pasado la noche.<ul><li>Duración de la estancia: <2 horas</li><li>Duración de la estancia: 2-6 horas</li><li>Duración de la estancia: 6-12 horas</li></ul></li></ul><ul><li><span>Turista</span>: visitante único cuyas estancias suman al menos 30 minutos en el área de hospedaje y que también haya pasado al menos una noche en la misma. Un turista será contabilizado desde la primer hasta la última noche en el área de hospedaje, siempre que no sea explícitamente visible en otra área de hospedaje pernoctando.<ul><li>Pernoctación 1 noche</li><li>Pernoctación 2 noches</li><li>Weekender: turista que ha pasado las noches de viernes y sábados en el área de hospedaje</li><li>Pernoctación 3-6 noches</li><li>Pernoctación 7-13 noches</li><li>Pernoctación > 13 noches</li></ul></li></ul>",
    glos7: "<span>Número total de pernoctaciones</span>: número de visitantes únicos, turistas y visitantes semanales multiplicado por el número de pernoctaciones para cada uno.",
    glos8: "<span>Hora de mayor afluencia</span>: hora del día con el mayor número de visitantes únicos entre todas las horas de la semana / mes analizado",
    glos9: "<span>Estancia promedio visitantes nacionales / internacionales</span>: tiempo promedio de estadía de visitantes nacionales únicos, incluso para cada individuo, la cantidad total de estadías en el área de hospedaje, sin contar el tiempo de pernoctación. <ul><li>Para Hikers nacionales / internacionales</li><li>Para Turistas nacionales / internacionales.</li></ul>",
    glos10: '<span>Concentración de Visitas" (presencia de turistas por hora)</span><ul><li>Totales</li><li>Nacionales / Internacionales</li><li>Máximo mínimo</li></ul>',
    glos11: "<span>Rankings</span>: Visitantes únicos nacionales e internacionales, posición / ranking en la región, en la provincia y en la CCAA, y clasificación de los 5 principales municipios de la provincia y regiones de la CCAA",
    glos12: "<span>Día de mayor afluencia</span>: día del mes / semana analizado donde se registra el mayor número de visitantes únicos.",
    "jan-19": "2019 Enero",
    "feb-19": "2019 Febrero",
    "mar-19": "2019 Marzo",
    "apr-19": "2019 Abril",
    "may-19": "2019 Mayo",
    "jun-19": "2019 Junio",
    "jul-19": "2019 Julio",
    "aug-19": "2019 Agosto",
    "sep-19": "2019 Septiembre",
    "oct-19": "2019 Octubre",
    "nov-19": "2019 Noviembre",
    "dec-19": "2019 Diciembre",
    "jan-20": "2020 Enero",
    "feb-20": "2020 Febrero",
    "mar-20": "2020 Marzo",
    "apr-20": "2020 Abril",
    "may-20": "2020 Mayo",
    "jun-20": "2020 Junio",
    "jul-20": "2020 Julio",
    "aug-20": "2020 Agosto",
    "sep-20": "2020 Septiembre",
    "oct-20": "2020 Octubre",
    "nov-20": "2020 Noviembre",
    "dec-20": "2020 Diciembre",
    "jan-21": "2021 Enero",
    "feb-21": "2021 Febrero",
    "mar-21": "2021 Marzo",
    "apr-21": "2021 Abril",
    avgStay: "Duración estancia en HORAS",
};
